import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MaterialModule } from '../../material/material/material.module';
import { CommonModule, NgFor } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrl: './clients.component.css',
  standalone: false,
})
export class ClientsComponent {
  clients: string[] = [];
  constructor(private router: Router) {
    for (let index = 0; index < 75; index++) {
      this.clients.push('Client ' + index);
    }
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }
}
